import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserCard from 'flarum/forum/components/UserCard';
import Link from 'flarum/common/components/Link';
export default function addFriendBadgeToUserCard() {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    if (!user) return;
    if (app.forum.attribute('friendshipShowBadgeOnUserCard') === false) return;
    if (user.attribute('friendshipShowOnUserCard') === false) return;
    const count = user.attribute('friendCount') || 0;
    if (count === 0) return;
    const color = app.forum.attribute('friendshipBadgeColor') || '#45698D';
    const icon = app.forum.attribute('friendshipBadgeIcon') || 'fas fa-hand-peace';
    items.add('friendCount', m(Link, {
      href: app.route('user.friendship', {
        username: user.username()
      }),
      className: "FriendshipBadge"
    }, m("i", {
      className: icon,
      style: {
        color
      }
    }), m("span", {
      className: "FriendshipBadge-count"
    }, count)), 12);
  });
}